// extracted by mini-css-extract-plugin
export var callCard = "_ni-0";
export var callMessageButton = "_ni-1";
export var helpIcon = "_ni-3";
export var helpIconContainer = "_ni-4";
export var verticalDivider = "_ni-2";